<section class="admin-panel">
  <app-card-shell class="admin-panel__shell" padding="lg">
    <header class="admin-panel__header">
      <h1 class="admin-panel__title">
        {{ "TITLES.ADMIN_PANEL" | translate }}
      </h1>
    </header>

    <nav class="admin-panel__nav" [attr.aria-label]="'TITLES.ADMIN_PANEL' | translate">
      @for (item of navigationItems; track item.route) {
        <a
          class="admin-panel__nav-link"
          [routerLink]="[item.route]"
          routerLinkActive="admin-panel__nav-link--active"
        >
          <span class="admin-panel__nav-label">
            {{ item.labelKey | translate }}
          </span>
          <span class="admin-panel__nav-description">
            {{ item.descriptionKey | translate }}
          </span>
        </a>
      }
    </nav>

    <div class="admin-panel__content">
      <router-outlet />
    </div>
  </app-card-shell>
</section>
